export default __webpack_public_path__ + "static/media/hero-bg-d.016f7966.jpg";